import * as React from 'react';
import ArrowClockwiseOutlined from './arrow-clockwise-outlined';
import ArrowClockwiseFilled from './arrow-clockwise-filled';
import type { IconCombinedProps } from './types';
const ArrowClockwiseCombined = React.forwardRef<SVGSVGElement, IconCombinedProps>((props, ref) => {
  const {
    isFocused,
    isHovered,
    isPressed,
    ...rest
  } = props;
  if (isFocused || isHovered || isPressed) {
    return <ArrowClockwiseFilled ref={ref} {...rest} />;
  }
  return <ArrowClockwiseOutlined ref={ref} {...rest} />;
});
export default ArrowClockwiseCombined;